export default __webpack_public_path__ + "static/stayc-450x520-991e323bcb044013e29deacf4e56aef1.jpg";